import { Menu, Transition } from "@headlessui/react";
import { Fragment, ReactNode } from "react";

import { LogoIcon, LogoutBlueIcon } from "./ui-icons/header";
import { Link } from "react-router-dom";
import Avatar from "./ui/avatar";
import { twMerge } from "tailwind-merge";
//

export type ListItem = { name: string; to: string; mailTo?: string; onClick?: () => void };

//

export const quitNavigationItems: ListItem[] = [
  { name: "Выйти", to: "https://login.microsoftonline.com/common/oauth2/v2.0/logout", onClick: () => { localStorage.clear() } },
];

function Header() {
  return (
    <header className="flex flex-row relative z-20 justify-between items-center py-5 border-b-[1px] border-[#DFE4EA]">
      <div className="container px-10 max-md:px-7.5 mx-auto">
        <div className="flex flex-row items-center justify-between">
          <Avatar />
          <div className="flex flex-col logo">
            <Link to="/">
              <LogoIcon />
            </Link>
          </div>
          <div className="flex flex-col items-center justify-center config">
            <div className="flex flex-row gap-2">
              {/* <div className="flex flex-col">
                <MenuButton list={adminNavigationItems}>
                  <AdminPanelBlueIcon />
                </MenuButton>
              </div> */}
              {/* <div className="flex flex-col">
                <MenuButton list={questionNavigationItems}>
                  <QuestionsBlueIcon />
                </MenuButton>
              </div> */}
              <div className="flex flex-col">
                <MenuButton list={quitNavigationItems}>
                  <LogoutBlueIcon />
                </MenuButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

// MobileHeader moved to `src/components/Header.mobile.tsx`

export function MenuButton({ list, children }: { list: ListItem[]; children: ReactNode }) {
  return (
    <Menu as="div" className="relative z-10 flex items-center">
      {({ open }) => (
        <div className="relative">
          <Menu.Button
            className={twMerge(
              open ? "border-[.5px] hover:border-darkblue border-darkblue bg-[#F9FAFB]" : "hover:border-[.5px] hover:border-[#DFE4EA] hover:bg-[#F9FAFB]",
              "menu-button relative flex justify-center items-center rounded-lg w-10 h-10 cursor-pointer"
            )}
          >
            {children}
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 whitespace-nowrap top-12 z-10 w-fit py-2.5 origin-top-right bg-white rounded-md shadow-custom ring-1 ring-black ring-opacity-5 focus:outline-none">
              {list.map(item => (
                <Menu.Item key={item.name}>
                  {({ active }) =>
                    item.mailTo ? (
                      <a
                        href={`mailto:${item.mailTo}`}
                        // onClick={(e) => emailClickHandler(e, item)}
                        className={twMerge(active ? "bg-[#F5F7FD] text-darkblue" : "", "block px-5 py-2 text-gray-700")}
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link to={item.to || "#"} onClick={item.onClick} className={twMerge(active ? "bg-[#F5F7FD] text-darkblue" : "", "block px-5 py-2 text-gray-700")}>
                        {item.name}
                      </Link>
                    )
                  }
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </div>
      )}
    </Menu>
  );
}
// MobileMenu used by MobileHeader lives in `src/layouts/MobileMenu.mobile.tsx` for dashboard; MobileHeader has its own lightweight menu
